import RoundInput from "@/components/RoundInput";
import * as S from "./styles";
import { Controller, useForm } from "react-hook-form";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Backdrop,
  ButtonGroup,
  CircularProgress,
  Fade,
  Grid,
  IconButton,
  Modal,
} from "@mui/material";
import { FutButton } from "@/components/FutButton";
import { api } from "@/services/api";
import {
  ICreateTicket,
  mutateCreateTicket,
  mutateEditTicket,
  fetchGetTickets,
  mutateDeleteTicket,
  mutateDeleteBet,
} from "@/hooks/fetchHooks/adminFetch";
import { toast } from "react-toastify";
import { useQueryClient } from "@tanstack/react-query";
import { FaRegTrashAlt } from "react-icons/fa";
import { FaAngleDown, FaPencil, FaPlus } from "react-icons/fa6";
import FutDatePicker from "@/components/FutDatePicker";
import { NumericFormat } from "react-number-format";
import { catchError } from "@/utils/catchError";
import { useMemo, useRef, useState } from "react";
import * as dateFns from "date-fns";
import { date } from "yup";
import FutSelect from "@/components/FutSelect";
import { MdOutlineDeleteSweep } from "react-icons/md";

interface TempFormProps {
  betName: string;
  nameTicket: string;
}

const ticketDefaultValues = {
  id: undefined,
  event: "",
  team1: "",
  team2: "",
  betType: "",
  betValue: "",
  betName: "",
  linkUrl: "",
  odd: "",
  matchDate: new Date(),
};

export default function Tickets() {
  const [open, setOpen] = useState(false);

  const ticketForm = useForm<ICreateTicket>({
    defaultValues: ticketDefaultValues,
  });

  const tempFormValues = useForm<TempFormProps>({
    defaultValues: {
      nameTicket: "",
    },
  });

  const watchId = ticketForm.watch("id");
  const queryClient = useQueryClient();

  const itemRef = useRef<Array<HTMLTableRowElement>>([]);

  const allTickets = fetchGetTickets({
    meta: { errorMessage: "Ocorreu um erro ao tentar conseguir os tickets" },
  });

  const createTicket = mutateCreateTicket({
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["admin/tickets"] });
      toast.success("Criado com sucesso!");
    },
    onError: (e) => {
      toast.error("Ocorreu um erro ao tentar criar o ticket");
    },
  });

  const editTicket = mutateEditTicket({
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["admin/tickets"] });
      toast.success("Editado com sucesso!");
    },
    onError: (e) => {
      toast.error("Ocorreu um erro ao tentar editar o ticket");
    },
  });

  const deleteTicket = mutateDeleteTicket({
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["admin/tickets"] });
      toast.success("deletado com sucesso!");
    },
    onError: (e) => {
      toast.error("Ocorreu um erro ao deletar o ticket");
    },
  });

  const deleteBet = mutateDeleteBet({
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["admin/tickets"] });
      toast.success("deletado com sucesso!");
    },
    onError: (e) => {
      toast.error("Ocorreu um erro ao deletar a bet");
    },
  });

  const ticketsBets = useMemo(() => {
    return allTickets.data?.reduce((accumulator, currentValue) => {
      const existingBetName = accumulator.find(
        (item) => item.value === currentValue.betName
      );
      if (!existingBetName) {
        accumulator.push({
          value: currentValue.betName,
          label: currentValue.betName,
        });
      }
      return accumulator;
    }, [] as { value: string; label: string }[]);
  }, [allTickets.data]);

  const handleCreate = async () => {
    const { betValue, odd, ...values } = ticketForm.getValues();

    createTicket.mutate(
      {
        ...values,
        odd: parseFloat(odd.toString()),
        betValue: parseFloat(betValue.toString()),
      },
      {
        onSuccess: () => {
          ticketForm.reset();
        },
      }
    );
  };

  const handleEdit = () => {
    const { created_at, updated_at, deleted_at, ...values } =
      ticketForm.getValues();

    editTicket.mutate(
      { ...values },
      {
        onSuccess: () => {
          ticketForm.reset(ticketDefaultValues);
          if (itemRef.current[values.id]) {
            itemRef.current[values.id].scrollIntoView();
          }
        },
      }
    );
  };

  const handleCreateTicket = () => {
    const inputValue = tempFormValues.getValues("nameTicket");
    if (!inputValue) {
      return;
    }
    setOpen(false);
    ticketsBets?.push({ label: inputValue, value: inputValue });
    tempFormValues.setValue("nameTicket", "");
    ticketForm.setValue("betName", inputValue);
  };

  const handleDelete = () => {
    const betName = ticketForm.getValues("betName");
    if (!betName) {
      return;
    }
    if (
      confirm(
        `Você tem certeza que deseja deletar ${betName}? essa ação deletará todas apostas dentro dele`
      )
    ) {
      deleteTicket.mutate(betName);

      ticketForm.setValue("betName", "");
    }
  };

  return (
    <>
      <S.GlobalWrapper>
        <S.WrapperInputs>
          <h3>{watchId ? "Modo de edição ativo" : undefined}</h3>
          <Grid container spacing={2}>
            <Grid item md={4} xs={12}>
              <RoundInput
                control={ticketForm.control}
                inputName="event"
                topLabel="Evento"
                size="small"
              />
            </Grid>
            <Grid item md={4} xs={12}>
              <RoundInput
                control={ticketForm.control}
                inputName="team1"
                topLabel="Time 1"
                size="small"
              />
            </Grid>
            <Grid item md={4} xs={12}>
              <RoundInput
                control={ticketForm.control}
                inputName="team2"
                topLabel="Time 2"
                size="small"
              />
            </Grid>
            <Grid item md={4} xs={12}>
              {/* <RoundInput
              control={ticketForm.control}
              inputName="betValue"
              topLabel="Valor da Bet"
              size="small"
            /> */}
              <p>Valor da bet</p>
              <Controller
                name="betValue"
                control={ticketForm.control}
                render={({ field: { onChange, ...fields } }) => (
                  <NumericFormat
                    {...fields}
                    onValueChange={(value) => {
                      onChange(value.value);
                    }}
                    decimalScale={2}
                    customInput={RoundInput}
                    size="small"
                  />
                )}
              />
            </Grid>
            <Grid item md={4} xs={12}>
              {/* <RoundInput
              control={ticketForm.control}
              inputName="odd"
              topLabel="odd"
              size="small"
            /> */}
              <p>Odd</p>
              <Controller
                name="odd"
                control={ticketForm.control}
                render={({ field: { onChange, ...fields } }) => (
                  <NumericFormat
                    {...fields}
                    onValueChange={(value) => {
                      onChange(value.value);
                    }}
                    decimalScale={2}
                    customInput={RoundInput}
                    size="small"
                  />
                )}
              />
            </Grid>
            <Grid item md={4} xs={12} display="flex" alignItems="flex-end">
              <FutDatePicker
                control={ticketForm.control}
                inputName="matchDate"
                disablePast
                sx={(props) => ({
                  width: "100%",
                  " .MuiInputBase-root": {
                    backgroundColor: props.palette.inputColor.main,
                  },
                })}
              />
            </Grid>
            <Grid item md={4} xs={12}>
              <RoundInput
                control={ticketForm.control}
                inputName="betType"
                topLabel="Tipo da Bet"
                size="small"
              />
            </Grid>
            <Grid item md={2.5} xs={12} display="flex" alignItems="flex-end">
              {ticketsBets ? (
                <FutSelect
                  control={ticketForm.control}
                  inputName="betName"
                  placeholderItem="Selecione um Ticket"
                  data={ticketsBets}
                  //@ts-ignore
                  sx={{ width: "100%" }}
                />
              ) : (
                <></>
              )}
            </Grid>

            <Grid item md={1.5} xs={12} display="flex" alignItems="flex-end">
              <S.CustomButtonGroup>
                <IconButton onClick={() => setOpen((prev) => !prev)}>
                  <FaPlus />
                </IconButton>

                <IconButton onClick={handleDelete}>
                  <FaRegTrashAlt />
                </IconButton>
                {/* 
                <IconButton>
                  <MdOutlineDeleteSweep />
                </IconButton> */}
              </S.CustomButtonGroup>
            </Grid>
            <Grid item md={4} xs={12}>
              <RoundInput
                control={ticketForm.control}
                inputName="linkUrl"
                topLabel="Link"
                size="small"
              />
            </Grid>
            <Grid
              item
              xs={12}
              mt={2}
              justifyContent="flex-end"
              display="flex"
              gap={3}
            >
              {watchId ? (
                <FutButton
                  isLoading={editTicket.isPending}
                  onClick={() => {
                    ticketForm.reset(ticketDefaultValues);
                  }}
                  variant="text"
                >
                  Cancelar edição
                </FutButton>
              ) : (
                <></>
              )}
              <FutButton
                isLoading={createTicket.isPending || editTicket.isPending}
                onClick={() => {
                  if (watchId) {
                    handleEdit();
                    return;
                  }
                  handleCreate();
                }}
              >
                {watchId ? "Editar" : "Enviar"}
              </FutButton>
            </Grid>
          </Grid>
        </S.WrapperInputs>
        {ticketsBets ? (
          ticketsBets?.map((key) => (
            <Accordion
              key={key.value}
              sx={(props) => ({
                mt: 2,
                backgroundColor: props.palette.backgroundColor.main,
              })}
            >
              <AccordionSummary
                expandIcon={<FaAngleDown />}
                aria-controls={`panel${key.value}-content`}
                id={`panel${key.value}`}
              >
                {key.value}
              </AccordionSummary>
              <AccordionDetails>
                <S.PaymentWrapper>
                  <S.PaymentTable>
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Evento</th>
                        <th>Times</th>
                        <th>Tipo da bet</th>
                        <th>Valor da Bet</th>
                        <th>Valor da odd</th>
                        <th>Data</th>
                        <th>Link</th>
                      </tr>
                    </thead>
                    <tbody>
                      {allTickets.data
                        ?.filter((el) => el.betName === key.value)
                        .map((el, i) => (
                          <tr
                            key={el.id}
                            ref={(element) =>
                              (itemRef.current[el.id] = element!)
                            }
                          >
                            <td>
                              {deleteBet.isPending ? (
                                <CircularProgress />
                              ) : (
                                <>
                                  <IconButton
                                    aria-label="delete"
                                    sx={{ fontSize: 18 }}
                                    onClick={() => {
                                      deleteBet.mutate(el.id);
                                    }}
                                  >
                                    <FaRegTrashAlt />
                                  </IconButton>
                                  <IconButton
                                    aria-label="edit"
                                    onClick={() => {
                                      const date = new Date(el.matchDate);
                                      ticketForm.reset({
                                        ...el,
                                        matchDate: date,
                                      });
                                      window.scrollTo(0, 0);
                                    }}
                                    sx={{ fontSize: 18 }}
                                  >
                                    <FaPencil />
                                  </IconButton>
                                </>
                              )}
                            </td>
                            <td>{el.event}</td>
                            <td>
                              {el.team1} vs {el.team2}
                            </td>
                            <td>{el.betType}</td>
                            <td>{el.betValue}</td>
                            <td>{el.odd}</td>
                            <td>
                              {typeof el.matchDate === "string"
                                ? dateFns.format(
                                    dateFns.parseISO(el.matchDate),
                                    "dd-MM-yyyy"
                                  )
                                : ""}
                            </td>
                            <S.CustomTd>{el.linkUrl}</S.CustomTd>
                          </tr>
                        ))}
                    </tbody>
                  </S.PaymentTable>
                </S.PaymentWrapper>
              </AccordionDetails>
            </Accordion>
          ))
        ) : (
          <p>Nenhuma tabela encontrada</p>
        )}
      </S.GlobalWrapper>
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 300,
          },
        }}
      >
        <Fade in={open}>
          <S.ModalWrapper>
            <S.ModalContainer>
              <S.CloseBtn>
                <button onClick={() => setOpen(false)}>X</button>
              </S.CloseBtn>

              <RoundInput
                control={tempFormValues.control}
                inputName="nameTicket"
                topLabel="Nome do Ticket"
                size="small"
                autoFocus
                onKeyUp={(event) => {
                  if (event.key === "Enter") {
                    handleCreateTicket();
                  }
                }}
              />
              <b>Dica: Enter é um atalho para criar o ticket</b>
              <FutButton onClick={handleCreateTicket}>Criar Ticket</FutButton>
            </S.ModalContainer>
          </S.ModalWrapper>
        </Fade>
      </Modal>
    </>
  );
}
